<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmTopConsumers from 'src/components/EnergyMonitoring/sections/EmTopConsumers.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { normalizeEnergyConfig } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyTopConsumers'> | undefined;
	export let staticPreview = false;

	$: config = normalizeEnergyConfig('dashEnergyTopConsumers', energyConfig);
</script>

<Container type="glass" noScroll fullHeight>
	<EmTopConsumers embedded {staticPreview} groupBy={config.groupBy} />
</Container>
